import { useEffect, useState, useRef  } from 'react';

export const useOrderPolling = (sessionId: string | null, enabled = true) => {
  const [orderInfo, setOrderInfo] = useState<string | null>(null);
  const [isOrderReady, setIsOrderReady] = useState(false);
  const [returnURL, setReturnURL] = useState<string | null>(null);
  const [isExpired, setIsExpired] = useState(false);

const MAX_POLL_DURATION_MS = 2 * 60 * 60 * 1000; // match server absolute cap (2h)
const POLL_INTERVAL_MS = 3000;
const startTimeRef = useRef<number>(Date.now());

  useEffect(() => {
  if (!sessionId || isOrderReady || !enabled) return;
  startTimeRef.current = Date.now(); // reset whenever polling (re)starts

  const safeSessionId = sessionId;

  const poll = async () => {
      if (Date.now() - startTimeRef.current > MAX_POLL_DURATION_MS) {
        setIsExpired(true);
        return;
      }
    try {
      const res = await fetch(
        `/api/netsuite/order-status?sessionId=${encodeURIComponent(safeSessionId)}`
      );

      const data = await res.json();

      if (data.ready) {
          setOrderInfo(data.cxml);
          setReturnURL(data.returnURL);
          setIsOrderReady(true);
        } else if (data.expired) {
          setIsExpired(true);
        }
      } catch (err) {
        console.error('Polling error:', err);
      }
    };

    poll();
    const interval = setInterval(poll, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [sessionId, isOrderReady, isExpired, enabled]);

  return {
    orderInfo,
    returnURL,
    isOrderReady,
    isExpired
  };
};

